import { render, staticRenderFns } from "./PaginatedJournalList.vue?vue&type=template&id=ab074c0a&"
import script from "./PaginatedJournalList.vue?vue&type=script&lang=ts&"
export * from "./PaginatedJournalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports